import { permitRestrictions } from '../../utils/constants/constants';
import { isCompletelyEmpty, removeEmptyFields, removeEmptyObjects } from '../../utils/data';

const PermitTables = ({ permits }) => {
  console.log("valid permits before:", permits)
  removeEmptyFields(permits);
  removeEmptyObjects(permits);
  console.log("valid permits after:", permits)
  if (isCompletelyEmpty(permits)) return null;

  return (
    <div>
      {permits.map((permit, index) => {
        const validRestrictions = permit?.Restrictions
        console.log("valid restrictions before:", validRestrictions)
        removeEmptyFields(validRestrictions);
        removeEmptyObjects(validRestrictions);
        console.log("valid restrictions after:", validRestrictions)
        return (
          <div key={index}>
            <th>Permit Class {permit.CommercialClassCode}</th>
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Issue Date</th>
                  <th>Expiration Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{permit.IssueDate}</td>
                  <td>{permit.ExpirationDate}</td>
                  <td>{permit.Status?.split('-')[1] || permit.Status}</td>
                </tr>
              </tbody>
            </table>

            {validRestrictions && validRestrictions.length > 0 && (
              <>
                <th>Permit Class {permit.CommercialClassCode} Restrictions</th>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr><th>Value</th></tr>
                  </thead>
                  <tbody>
                    {validRestrictions.map((r, idx) => (
                      <tr key={idx}>
                        <td>{r.RestrictionText || permitRestrictions[r.Code]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

            {permit.EndorsementGroupCode?.length > 0 && (
              <>
                <th>Permit Class {permit.CommercialClassCode} Endorsements</th>
                <table className="table table-striped table-bordered">
                  <thead>
                    <tr><th>Value</th></tr>
                  </thead>
                  <tbody>
                    {permit.EndorsementGroupCode.map((e, idx) => (
                      <tr key={idx}>
                        <td>{e.split('-')[1]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PermitTables;
